import {GetSessionsListUseCase} from '../useCases/GetSessionsListUseCase';
import {GetSessionDetailsUseCase} from '../useCases/GetSessionDetailsUseCase';
import {GetSessionTrackUseCase} from '../useCases/GetSessionTrackUseCase';
import {GetMarketerSessionsUseCase} from '../useCases/GetMarketerSessionsUseCase';

/**
 * Singleton factory — lazily instantiates use cases so the store can pick
 * them up without dragging the whole feature into its module graph.
 */
class MarketerTrackingFactoryClass {
  private static instance: MarketerTrackingFactoryClass;
  private getSessionsList: GetSessionsListUseCase | null = null;
  private getSessionDetails: GetSessionDetailsUseCase | null = null;
  private getSessionTrack: GetSessionTrackUseCase | null = null;
  private getMarketerSessions: GetMarketerSessionsUseCase | null = null;

  private constructor () {}

  public static getInstance (): MarketerTrackingFactoryClass {
    if (!MarketerTrackingFactoryClass.instance) {
      MarketerTrackingFactoryClass.instance = new MarketerTrackingFactoryClass();
    }
    return MarketerTrackingFactoryClass.instance;
  }

  public createGetSessionsListUseCase (): GetSessionsListUseCase {
    if (!this.getSessionsList) this.getSessionsList = new GetSessionsListUseCase();
    return this.getSessionsList;
  }

  public createGetSessionDetailsUseCase (): GetSessionDetailsUseCase {
    if (!this.getSessionDetails) this.getSessionDetails = new GetSessionDetailsUseCase();
    return this.getSessionDetails;
  }

  public createGetSessionTrackUseCase (): GetSessionTrackUseCase {
    if (!this.getSessionTrack) this.getSessionTrack = new GetSessionTrackUseCase();
    return this.getSessionTrack;
  }

  public createGetMarketerSessionsUseCase (): GetMarketerSessionsUseCase {
    if (!this.getMarketerSessions) this.getMarketerSessions = new GetMarketerSessionsUseCase();
    return this.getMarketerSessions;
  }

  public reset (): void {
    this.getSessionsList = null;
    this.getSessionDetails = null;
    this.getSessionTrack = null;
    this.getMarketerSessions = null;
  }
}

export const MarketerTrackingFactory = MarketerTrackingFactoryClass.getInstance();
